/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { Txn } from '@src/app/model/txn';
import { MessageService } from '@src/app/shared/message.service';


@Injectable({
    providedIn: 'root'
})
export class BankTransferService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);


    /*
        Only Used to post entries
    */
    protected get baseUrl(): string {
        return this.getAjaxPath('bank-accounts/transfer');
    }
    protected cache: Txn[];
    protected typeString = Txn.TYPE.BANK_TRAN.name;

}
